import dvaModelExtend from 'dva-model-extend';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';

import { ENTITY_NAME, FETCH_PARAMS, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);

const _model = createCrudModel({
  namespace: MODEL_NAME,
  fetchRoute: FETCH_ROUTE,
  fetchParams: FETCH_PARAMS,
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: true },
  state: {
    showVoidModal: { state: false, id: null },
    showConfigurationsDrawer: false,
    drawerDelegationItem: null,
    showDelegatedTasksDrawer: false,
    drawerDelegatedTasksContext: null,
  },
  effects: {
    *showVoidModal({ payload }, { put }) {
      yield put({ type: 'queryShowVoidModal', payload });
    },

    *closeVoidModal(_, { put }) {
      yield put({ type: 'queryShowVoidModal', payload: { state: false, id: null } });
    },

    *showConfigurationsDrawer({ payload }, { put }) {
      yield put({
        type: 'queryConfigurationsDrawer',
        payload: { open: payload.open, item: payload.item },
      });
    },

    *showDelegatedTasksDrawer({ payload }, { put }) {
      yield put({
        type: 'queryDelegatedTasksDrawer',
        payload: { open: payload.open, context: payload.context },
      });
    },

    *voidDelegation({ payload }, { call, put }) {
      try {
        const { id, voidedReason } = payload;
        yield call(api.create, {
          route: `${FETCH_ROUTE}/void/${id}`,
          data: { voidedReason },
        });
        yield put({ type: 'success', payload: { success: true } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (e) {
        if (e?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: e.message },
          });
        }
      } finally {
        yield put({ type: 'queryShowVoidModal', payload: { state: false, id: null } });
      }
    },
  },
  reducers: {
    queryShowVoidModal(state, { payload }) {
      return {
        ...state,
        showVoidModal: payload,
      };
    },
    queryConfigurationsDrawer(state, { payload }) {
      return {
        ...state,
        showConfigurationsDrawer: payload.open,
        drawerDelegationItem: payload.item ?? null,
      };
    },
    queryDelegatedTasksDrawer(state, { payload }) {
      return {
        ...state,
        showDelegatedTasksDrawer: payload.open,
        drawerDelegatedTasksContext: payload.context ?? null,
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace: MODEL_NAME });
